import { useAuth } from '@/services/auth';

export function useMasqAccessLevel() {
  const auth = useAuth();
  const isMasq = auth.account.is_masq === true;
  return {
    isMasqWithoutAccess: isMasq && !auth.user.hasReadMasqAccess,
    isMasqWithLimitedAccess: isMasq && !auth.user.isSuperUser && !auth.user.canReadWriteMasq,
  };
}
